import { useState } from 'react'
import FormLoader from '../../../../components/loader/FormLoader'
import Modal from '../../../../components/modal/Modal'
import { useParams } from 'react-router-dom'
import { uploadFile } from '../../../../utils/Api'
import { useGlobalContext } from '../../../../utils/Context'

function UpdateBooking({ fetchBooking, setShowUpdate }: any) {
  const { id } = useParams()
  const { notify, profile } = useGlobalContext()
  const [formData, setFormData] = useState<any>({
    trackingId: '',
    pdf: null,
    location: profile?.location || '',
  })
  const [loading, setLoading] = useState(false)
  async function cancelBooking() {
    if (!formData.trackingId || !formData.pdf) {
      notify('warn', 'Input All Fields')
      return
    }
    const submitData = new FormData()
    submitData.append('trackingId', formData.trackingId)
    submitData.append('pdf', formData.pdf)
    submitData.append('location', formData.location)
    setLoading(true)
    let endpoint = `admin/update-floating/${id}`
    uploadFile(submitData, endpoint)
      .then((result: any) => {
        if (result.status === 200) {
          notify('success', 'Booking Status Updated')
          setShowUpdate(false)
          fetchBooking()
        } else {
          notify('error', result.message)
        }
        setLoading(false)
      })
      .catch(() => {
        setLoading(false)
      })
  }
  return (
    <Modal position='center'>
      <div className='payment-modal'>
        <h1>Update Booking Status</h1>
        <p>
          Note: will update the tracking ID and upload the AWB of this booking.
        </p>
        <input
          type='text'
          value={formData.trackingId}
          placeholder='Enter Tracking ID'
          onChange={(e) =>
            setFormData({ ...formData, trackingId: e.target.value })
          }
        />
        <div className='div'>
          <input
            type='file'
            name='pdf'
            id='pdf'
            accept='.pdf'
            onChange={(e: any) =>
              setFormData({ ...formData, pdf: e.target.files[0] })
            }
          />
        </div>
        {loading ? (
          <FormLoader position='center' />
        ) : (
          <div className='buttons flex justify-center'>
            <button onClick={() => setShowUpdate(false)}>Cancel</button>
            <button className='proceed' onClick={cancelBooking}>
              Proceed
            </button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export default UpdateBooking
